import { CompanyOwnerCompany, CompanyOwnerUser, CompanyPayoutDetails } from '../../types/companyOwner';
import {
  AuthTokenBundle,
  clearAuthTokenBundle,
  getAccessToken,
  saveAuthTokenBundle,
} from './authTokens';

const COMPANY_OWNER_AUTH_TOKEN_KEY = 'shiftwagon_company_owner_auth_token';
const COMPANY_OWNER_AUTH_USER_KEY = 'shiftwagon_company_owner_auth_user';
const COMPANY_OWNER_COMPANY_KEY = 'shiftwagon_company_owner_company';
const COMPANY_OWNER_CLAIM_TOKEN_KEY = 'shiftwagon_company_owner_claim_token';
const COMPANY_OWNER_PAYOUT_DETAILS_KEY = 'shiftwagon_company_owner_payout_details';

export function saveCompanyOwnerAuthToken(token: string): void {
  saveAuthTokenBundle('companyOwner', { accessToken: token });
}

export function getCompanyOwnerAuthToken(): string | null {
  return getAccessToken('companyOwner');
}

export function saveCompanyOwnerAuthTokens(bundle: AuthTokenBundle): void {
  saveAuthTokenBundle('companyOwner', bundle);
}

export function clearCompanyOwnerAuthToken(): void {
  clearAuthTokenBundle('companyOwner');
  sessionStorage.removeItem(COMPANY_OWNER_AUTH_TOKEN_KEY);
}

export function saveCompanyOwnerAuthUser(user: CompanyOwnerUser): void {
  sessionStorage.setItem(COMPANY_OWNER_AUTH_USER_KEY, JSON.stringify(user));
}

export function getCompanyOwnerAuthUser(): CompanyOwnerUser | null {
  const raw = sessionStorage.getItem(COMPANY_OWNER_AUTH_USER_KEY);
  if (!raw) return null;

  try {
    return JSON.parse(raw) as CompanyOwnerUser;
  } catch {
    return null;
  }
}

export function clearCompanyOwnerAuthUser(): void {
  sessionStorage.removeItem(COMPANY_OWNER_AUTH_USER_KEY);
}

export function saveCompanyOwnerCompany(company: CompanyOwnerCompany): void {
  sessionStorage.setItem(COMPANY_OWNER_COMPANY_KEY, JSON.stringify(company));
}

export function getCompanyOwnerCompany(): CompanyOwnerCompany | null {
  const raw = sessionStorage.getItem(COMPANY_OWNER_COMPANY_KEY);
  if (!raw) return null;

  try {
    return JSON.parse(raw) as CompanyOwnerCompany;
  } catch {
    return null;
  }
}

export function clearCompanyOwnerCompany(): void {
  sessionStorage.removeItem(COMPANY_OWNER_COMPANY_KEY);
}

export function saveCompanyOwnerClaimToken(token: string): void {
  sessionStorage.setItem(COMPANY_OWNER_CLAIM_TOKEN_KEY, token);
}

export function getCompanyOwnerClaimToken(): string | null {
  return sessionStorage.getItem(COMPANY_OWNER_CLAIM_TOKEN_KEY);
}

export function clearCompanyOwnerClaimToken(): void {
  sessionStorage.removeItem(COMPANY_OWNER_CLAIM_TOKEN_KEY);
}

export function saveCompanyOwnerPayoutDetails(payoutDetails: CompanyPayoutDetails): void {
  sessionStorage.setItem(COMPANY_OWNER_PAYOUT_DETAILS_KEY, JSON.stringify(payoutDetails));
}

export function getCompanyOwnerPayoutDetails(): CompanyPayoutDetails | null {
  const raw = sessionStorage.getItem(COMPANY_OWNER_PAYOUT_DETAILS_KEY);
  if (!raw) return null;

  try {
    return JSON.parse(raw) as CompanyPayoutDetails;
  } catch {
    return null;
  }
}

export function clearCompanyOwnerPayoutDetails(): void {
  sessionStorage.removeItem(COMPANY_OWNER_PAYOUT_DETAILS_KEY);
}

export function clearCompanyOwnerAuthFlow(): void {
  clearCompanyOwnerAuthToken();
  clearCompanyOwnerAuthUser();
  clearCompanyOwnerCompany();
  clearCompanyOwnerClaimToken();
  clearCompanyOwnerPayoutDetails();
}
